
import { defineComponent, PropType } from 'vue';
import DriveAllFiles from '../view-models/DriveAllFiles.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
import { useDriveStore } from '../store/driveStore';
import { useMainStore } from '@/store/mainStore';
import NotificationService from '@/services/NotificationService';
import { ICaseFilesManage, ITemporaryFile } from '@/types/interfaces';

export default defineComponent({
  props: {
    customControl: { type: Boolean, default: false },
    temporaryFiles: { type: Array as PropType<ITemporaryFile[]> },
  },
  emits: ['close', 'addSelectedFiles'],
  components: {
    DriveAllFiles,
    AppHeader,
    AppSearch,
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();

    function fileUpdate() {
      if (props.customControl) {
        emit('addSelectedFiles', { selected: driveStore.files.filter((photo) => photo.selected), deselected: driveStore.files.filter((photo) => !photo.selected) });
        return;
      }

      const promises: Promise<any>[] = [];
      const addFilePayload = {
        id: driveStore.currentCase.id!,
        fileIds: [],
      } as ICaseFilesManage;
      const removeFilePayload = {
        id: driveStore.currentCase.id!,
        fileIds: [],
      } as ICaseFilesManage;

      addFilePayload.fileIds = driveStore.files
        .filter((photo) => photo.selected)
        .filter((photo) => !driveStore.currentCase.files.find((caseItem) => caseItem.contentId === photo.contentId))
        .map((photo) => photo.id);

      removeFilePayload.fileIds = driveStore.files
        .filter((photo) => !photo.selected)
        .filter((photo) => driveStore.currentCase.files.find((caseItem) => caseItem.contentId === photo.contentId))
        .map((photo) => driveStore.currentCase.files.find((caseItem) => caseItem.contentId === photo.contentId)!.id);

      if (addFilePayload.fileIds.length) {
        promises.push(driveStore.addFilesToCase(addFilePayload));
      }
      if (removeFilePayload.fileIds.length) {
        promises.push(driveStore.removeFilesFromCase(removeFilePayload));
      }

      if (promises.length) {
        Promise.all(promises)
          .then((responses) => {
            if (responses.every((response) => response.success)) {
              driveStore.currentCase.updated = Date.now();
              // NotificationService.notifySuccess();
            }
          });
      }
      emit('close');
    }

    return {
      driveStore,
      fileUpdate,
      mainStore,
    };
  },
});
